import companyIcon from "../assets/CompanyIcon.jpeg";

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <img src={companyIcon} alt="WaschenNPure Logo" className="company-logo" />
        <div>
          <h1>WaschenNPure</h1>
          <p className="tagline">Pure & Powerful Cleaning Solutions</p>
        </div>
      </div>
    </header>
  );
}

export default Header;
